"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface EducationItem {
  id: string;
  title: string;
  trainer?: string;
  bullets?: string[];
  fullWidth?: boolean;
}
const seelenfriedenItems: string[] = ["gehe ich gerne Wandern, Spazieren", "Liebe ich Blumen", "mache Yoga, Krafttraining", "Meditiere und betreibe Achtsamkeitstraining", "geniesse feines Essen und ein Glas Wein", "verbringe Zeit mit meinen Liebsten", "entspanne mich bei kreativen Tätigkeiten"];
const educationItems: EducationItem[] = [{
  id: "reiki-master",
  title: "Reiki Ausbildung 1-3 Grad, Reiki Meisterin/Lehrerin, ich bin schule Bern"
}, {
  id: "tiefenentspannung",
  title: "Instruktorin und Kursleiterin für Tiefenentspannung in den Methoden Yoga Nidra und Meditativer Zentrierung",
  trainer: "bei Daniela Michel-Gremaud",
  bullets: ["Prozesse und Auswirkungen bei körperlichen und geistig- psychischer Entspannung", "Leiten und durchführen von Gruppenkursen und Einzelsitzungen", "Grundwissen über die Dynamik einer Gruppe", "Kennen und Einsetzen von einzelnen Konzepten aus der Transaktionsanalyse", "Persönlichkeitsentwicklung mit Tiefenentspannung", "Theoretischer Hintergrund von Yoga Nidra", "Anwendungsbereiche von YN", "Ablauf und Wirkung von YN", "Erarbeiten eines Sankalpas (positiver Vorsatz)", "Theoretischer Hintergrund von Meditativer Zentrierung", "Anwendung von MZ", "Ablauf von MZ und De- Zentrierung", "Herausarbeiten intuitiver Botschaften und Umgang mit diesen"],
  fullWidth: true
}, {
  id: "new-spirit",
  title: "New Spirit Ausbildung zur sensitiven und medialen Beraterin",
  trainer: "bei Bahar Yilmaz und Jeffrey Kastenmüller",
  bullets: ["Lesen in der Aura und im Quellfeld", "Chakra- Healing/ Chakra reading", "Remote viewing", "Jenseitskontakte", "DNA-upgrade", "Heart Reading", "Lesen der Energieportale", "Energiecoaching", "Spirituelles Coaching", "usw.."],
  fullWidth: true
}, {
  id: "medialitaet-heilen",
  title: "Ausbildung in Medialität und Energetisches Heilen, ich bin schule Bern",
  bullets: ["Meditation", "Hermetische Gesetze", "Luzides Träumen", "Schöpfungslehre und Quantenphysik", "Kontakt mit geistigen Wesen", "Chakra System", "Bewusstwerdungsprozesse", "usw"],
  fullWidth: true
}, {
  id: "seminare-medialitaet",
  title: "Verschiedene Seminare in Medialität und Energetisches Heilen"
}, {
  id: "seminar-dorn-breuss",
  title: "Seminar Dorn Breuss Massage"
}];
export default function UberUns() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="44694" id="über-mich" className="bg-background py-20 md:py-28">
      <div ref={ref} className={`container mx-auto px-4 md:px-8 max-w-6xl transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
        {/* Top Grid: Intro + Portrait */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-start">
          {/* Portrait: Order 1 on mobile, Order 2 on desktop (sticky) */}
          <div className="order-1 md:order-2 md:col-span-5 md:sticky md:top-24 self-start">
            <div className="relative mx-auto max-w-sm md:max-w-none">
              {/* Subtle Swiss offset frame motif */}
              <div aria-hidden="true" className="absolute -inset-3 rounded-md bg-secondary/40 border border-border/60 pointer-events-none translate-x-2 translate-y-2 md:translate-x-3 md:translate-y-3" />
              <div className="relative overflow-hidden rounded-md border border-border bg-card">
                <img src="https://wandelherz.ch/wp-content/uploads/2026/08/364f3e60-9d27-4705-a9ec-e5c296c72f2a.jpg" alt="Portrait der Gründerin in warmem Licht" className="w-full h-auto object-cover object-center aspect-[4/5] block" />
              </div>
            </div>
          </div>

          {/* Left Column: Heading, Intro, Seelenfrieden */}
          <div className="order-2 md:order-1 md:col-span-7 flex flex-col">
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl font-light text-foreground leading-tight tracking-tight">
              Über mich
            </h1>

            <Separator className="h-[1px] bg-border my-6" />

            <p className="font-sans text-base md:text-lg leading-relaxed text-foreground/90 font-normal">
              Seit über einem Jahrzehnt begleite ich Menschen auf ihrem Weg zu
              innerer Klarheit und emotionaler Resilienz. Meine Arbeit verbindet
              achtsamkeitsbasierte Methoden mit tiefenpsychologischem
              Verständnis, um Räume für echte Transformation zu schaffen. In
              meinen Retreats und Einzelsitzungen lade ich dich ein, die Stille
              als Kraftquelle neu zu entdecken und deine persönliche Vision mit
              neuer Energie zu beleben. Mein Herzenswunsch ist es, dich auf
              deinem Wandel zu begleiten, dein Potenzial zu entfalten, dich
              aufblühen zu sehen und dir Wege aufzuzeigen, wie du es schaffen
              kannst loszulassen, was du lieber festhalten möchtest und
              weiterzugehen, wo du lieber stehen bleiben würdest.
            </p>

            {/* Für meinen Seelenfrieden Card */}
            <div className="mt-10 p-6 md:p-8 rounded-md bg-secondary/30 border border-border">
              <h2 className="font-serif text-xl md:text-2xl font-light text-foreground mb-4">
                Für meinen Seelenfrieden
              </h2>
              <ul className="space-y-2.5 font-sans text-sm md:text-base text-foreground/90">
                {seelenfriedenItems.map((item, index) => <li key={index} className="flex items-start gap-3">
                    <span aria-hidden="true" className="inline-block mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                    <span>{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        {/* Meine Ausbildungen Section (Full width stack / grid) */}
        <div className="mt-16 md:mt-24 pt-12 border-t border-border">
          <div className="max-w-2xl mb-8">
            <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-light text-foreground">
              Meine Ausbildungen:
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {educationItems.map(item => {
            const isWide = item.fullWidth;
            return <div key={item.id} className={`rounded-md bg-card border border-border p-6 md:p-8 transition-colors ${isWide ? "md:col-span-2" : "md:col-span-1"}`}>
                  <h3 className="font-serif text-lg md:text-xl font-normal text-foreground leading-snug">
                    {item.title}
                  </h3>

                  {item.trainer && <p className="mt-1 font-sans text-xs md:text-sm text-foreground/75 italic">
                      {item.trainer}
                    </p>}

                  {item.bullets && item.bullets.length > 0 && <ul className={`mt-5 gap-x-8 gap-y-2.5 font-sans text-sm md:text-base text-foreground/90 ${item.bullets.length > 6 ? "grid grid-cols-1 md:grid-cols-2" : "space-y-2.5"}`}>
                      {item.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-3">
                          <span aria-hidden="true" className="inline-block mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />
                          <span>{bullet}</span>
                        </li>)}
                    </ul>}
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}